<template>
  <el-popover v-if="!store.hasEName" :visible="visible" placement="top" :width="160">
    <p>您还没有进行企业认证！</p>
    <div style="text-align: right; margin: 0">
      <el-button size="small" text @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="toCertificate">去认证</el-button>
    </div>
    <template #reference>
      <el-button :type="props.type" @click="operate">
        <slot />
      </el-button>
    </template>
  </el-popover>
  <el-button :type="type" @click="operate">
    <slot />
  </el-button>
  <DialogCertificate v-model:visible="certificateShow" />
</template>

<script setup>
import { ref } from 'vue';
import storeEuser from '@/config/store-euser';
import DialogCertificate from './DialogCertificate.vue';

const emit = defineEmits(['click']);

const props = defineProps({
  type: {
    type: String,
    default: 'primary',
  },
});

const visible = ref(false);
const store = storeEuser();

function operate() {
  // if (!store.hasEName) {
  //   visible.value = true;
  // } else {
  emit('click');
  // }
}

const certificateShow = ref(false);
function toCertificate() {
  certificateShow.value = true;
  visible.value = false;
}
</script>
